import { Injectable } from '@angular/core';

import { toFixed } from '../../../core/services/utils/numbers';

@Injectable({
    providedIn: 'root'
})
export class ClassificacaoFaturamentoCalculoService {
    /** Calcula o valor do faturamento mensal dividindo o valor anual por 12 */
    calcularValorFaturamentoMensal(valorFaturamentoAnual: number): number {
        return toFixed(valorFaturamentoAnual / 12, 2);
    }

    /** Calcula o valor do faturamento anual multiplicando o valor mensal por 12 */
    calcularValorFaturamentoAnual(valorFaturamentoMensal: number): number {
        return toFixed(valorFaturamentoMensal * 12, 2);
    }
}
